/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Enables the corporate partnership program: coupon-batch invite emails, auto-assignment of corporate codes at registration, and the corporate-referral welcome email for unmatched external referrals. Off when absent.
 * @export
 * @interface CorporateProgramModule
 */
export interface CorporateProgramModule {
    /**
     * 
     * @type {boolean}
     * @memberof CorporateProgramModule
     */
    enabled?: boolean;
    /**
     * How many months a corporate batch invoice covers. Falls back to the legacy 12 when absent.
     * @type {number}
     * @memberof CorporateProgramModule
     */
    invoice_coverage_months?: number;
    /**
     * How many days before coverage ends a batch shows as overdue, prompting renewal invoicing. Falls back to the legacy 15 when absent.
     * @type {number}
     * @memberof CorporateProgramModule
     */
    renewal_lead_days?: number;
}

/**
 * Check if a given object implements the CorporateProgramModule interface.
 */
export function instanceOfCorporateProgramModule(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CorporateProgramModuleFromJSON(json: any): CorporateProgramModule {
    return CorporateProgramModuleFromJSONTyped(json, false);
}

export function CorporateProgramModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): CorporateProgramModule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'invoice_coverage_months': !exists(json, 'invoice_coverage_months') ? undefined : json['invoice_coverage_months'],
        'renewal_lead_days': !exists(json, 'renewal_lead_days') ? undefined : json['renewal_lead_days'],
    };
}

export function CorporateProgramModuleToJSON(value?: CorporateProgramModule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'invoice_coverage_months': value.invoice_coverage_months,
        'renewal_lead_days': value.renewal_lead_days,
    };
}

